import { render, staticRenderFns } from "./ownerarchiveHistory.vue?vue&type=template&id=2020b53c&scoped=true&"
import script from "./ownerarchiveHistory.vue?vue&type=script&lang=js&"
export * from "./ownerarchiveHistory.vue?vue&type=script&lang=js&"
import style0 from "./ownerarchiveHistory.vue?vue&type=style&index=0&id=2020b53c&lang=less&scoped=true&"
import style1 from "./ownerarchiveHistory.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020b53c",
  null
  
)

export default component.exports